import React from "react";
import './button.scss';
import GithubIcon from '../../assets/icons/Github.svg';

const GithubButton = () => {
  return <div onClick={()=>window.open("https://github.com/ravin-perera")} 
  className="icon-button"><img src={GithubIcon} alt="Github Button" style={{ width: "24px", marginRight: "8px" }} /><h5>Github</h5></div>;
};

export default GithubButton;